const mobileMenuInit = () => {
  if (window.innerWidth > 480) {
    return;
  }

  const btn = document.querySelector('a#x-btn-navbar.x-btn-navbar');
  if (! (btn instanceof HTMLElement)) {
    return;
  }

  const body = document.body;
  if (! (body instanceof HTMLBodyElement)) {
    return;
  }

  btn.addEventListener('transitionend', (e) => {
    if (e.target.getAttribute('aria-expanded') === 'false') {
      body.classList.remove('x-mobile-navbar-open');
    } else {
      body.classList.add('x-mobile-navbar-open');
    }
  });
}

const closeSearchModalOnButtonClick = () => {
  const searchOverlay = document.querySelector('.x-searchform-overlay-inner .x-container');
  if (! (searchOverlay instanceof HTMLElement)) {
    return;
  }

  const logic = (event) => {
    if (
      ! event.target.closest('.search-modal-close') &&
      ! event.target.closest('.submit-button')
    ) {
        event.preventDefault();
        event.stopPropagation();

        searchOverlay.querySelector('.search-query').focus();
    }
  }

  if ('ontouchstart' in window) {
    searchOverlay.addEventListener('touchstart', logic);
  } else {
    searchOverlay.addEventListener('click', logic);
  }
}

/**
 * This needs because parent theme has a bug with the search button on tablet and click event works along with touch event.
 */
const fixBtnNavbarSearch = () => {
  const searchBtn = document.querySelector('.x-btn-navbar-search');
  if (! (searchBtn instanceof HTMLElement)) {
    return;
  }

  let touchStartTime;

  searchBtn.addEventListener('touchstart', function(e) {
      touchStartTime = Date.now();
  }, { passive: true });

  searchBtn.addEventListener('touchend', function(e) {
      if (Date.now() - touchStartTime < 200) {  // Only process quick taps.
          e.preventDefault();
          e.stopPropagation();
      }
  }, { passive: false });
}

const setEqualHeight = () => {
  const parentElements = document.querySelectorAll('.su-posts');
  if (! (parentElements instanceof NodeList) || parentElements.length === 0) {
    return;
  }

  parentElements.forEach((parentElement) => {
    if (! (parentElement instanceof HTMLElement)) {
      return;
    }

    const elements = parentElement.querySelectorAll('.su-singlePost');
    if (! (elements instanceof NodeList) || elements.length === 0) {
      return;
    }

    let maxHeight = 0;
    elements.forEach((element) => {
      const height = element.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    elements.forEach((element) => {
      element.style.height = maxHeight + 'px';
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mobileMenuInit();
  closeSearchModalOnButtonClick();
  fixBtnNavbarSearch();
  setEqualHeight();

  window.addEventListener('resize', () => {
    mobileMenuInit();
    setEqualHeight();
  });
});
